import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InterFrameCommService } from '@vapor/angular-core';
//import { map, tap } from 'rxjs';
import { map } from 'rxjs';
import * as fromGlobalModel from './interframe-global.model';

/**
 * This service is a singleton for the whole application, provided at the root level.
 * Its primary purpose is to handle messages received from a host application
 * when this application is embedded within an iframe. It acts as the main
 * entry point for all inter-frame communication originating from outside.
 */
@Injectable({
    providedIn: 'root'
})
export class InterframeGlobalService {
    private readonly interFrameCommService = inject(InterFrameCommService);
    private readonly bizHandlers = inject(
        fromGlobalModel.INTERFRAME_BIZ_HANDLER_TOKEN
    );

    private readonly outboundMessage = inject(
        fromGlobalModel.INTERFRAME_MESSAGE_OUTBOUND_TOKEN
    );

    constructor() {
        console.log(
            '+++ GLOBAL INTERFRAME CREATED +++',
            this.interFrameCommService
        );

        // const targetFrame = window.parent.frames[0];
        // if (targetFrame) {
        //     console.log('start handshake', targetFrame)
        //     this.interFrameCommService.startHandshake(targetFrame);
        // }

        this.interFrameCommService.rawMessage$
            .pipe(
                // Utile per debug
                // tap((e) => {
                //     debugger;
                //     console.log(e);
                // }),
                map((e: any) => e[0]),
                fromGlobalModel.filterInterFrameBilMsg(),
                takeUntilDestroyed()
            )
            .subscribe(this.handleMessage.bind(this));
    }

    private handleMessage(msg: fromGlobalModel.InterFrameBilMsg): void {
        console.log('+++ GLOBAL INTERFRAME MSG RECEIVED +++', msg);

        try {
            // Iterate through all registered handlers
            for (const handler of this.bizHandlers) {
                const resp = handler.handleMessage(msg);
                if (resp) {
                    this.sendResponse(resp);
                }
            }
        } catch (error) {
            this.handleError(error, msg);
        }
    }

    private handleError(
        error: unknown,
        originalMsg: fromGlobalModel.InterFrameBilMsg
    ): void {
        console.error('+++ GLOBAL INTERFRAME ERROR +++', error);

        const errorResponse = fromGlobalModel.createInterFrameErrorResponse({
            originalMessage: originalMsg.Command,
            code: error instanceof Error ? error.name : 'UnknownError',
            message: error instanceof Error ? error.message : String(error)
        });

        this.sendResponse(errorResponse);
    }

    private sendResponse(body: unknown): void {
        this.interFrameCommService.sendSyncData(
            fromGlobalModel.escapeString(JSON.stringify(body)),
            fromGlobalModel.CHUNK_MSG_TYPE_NO_ENCODE,
            fromGlobalModel.CHUNK_MESSAGE_FORMAT_EMPTY,
            0,
            () => {},
            () => {}
        );
    }

    public sendMessageToParent(msg: fromGlobalModel.InterFrameBilMsg): void {
        try {
            if (this.outboundMessage) {
                this.outboundMessage.sendToParent(msg);
            }

            this.sendResponse(msg);
        } catch (error) {
            console.error('Error sending message to parent:', error);
            this.handleError(error, msg);
        }
    }
}
